import { useEffect, useState } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Flex, Input, Button, Colors, BinLine } from '@revenuemarket/cds';
import { Form, Typography } from 'antd';

import { css } from '~libs/emotion';

interface Props {
  representatives: { id: number | null; name: string }[];
  onChange: (representatives: { id: number | null; name: string }[]) => void;
}

const BusinessEntityRepresentativeFormItems = (props: Props) => {
  const [representatives, setRepresentatives] = useState<{ id: number | null; name: string }[]>([
    ...props.representatives,
  ]);

  const onRemoveRepresentative = (index: number) => {
    const newRepresentativeInfo = [...representatives];
    newRepresentativeInfo.splice(index, 1);
    setRepresentatives([...newRepresentativeInfo]);
  };

  const onAddRepresentative = () => {
    setRepresentatives([...representatives, { id: null, name: '' }]);
  };

  const onEditRepresentative = (index: number, value: string) => {
    const newRepresentativeInfo = [...representatives];
    newRepresentativeInfo[index].name = value;
    setRepresentatives([...newRepresentativeInfo]);
  };

  useEffect(() => {
    props.onChange([...representatives]);
  }, [representatives]);

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          width: '100%',
        }}
      >
        {representatives.map((representative, index) => (
          <Form.Item
            key={index}
            label={
              index === 0 ? (
                <Flex align="center" gap={4}>
                  <Typography.Text
                    style={{
                      color: Colors.gray800,
                    }}
                  >
                    대표자명
                  </Typography.Text>
                </Flex>
              ) : (
                ''
              )
            }
            style={{
              marginBottom: 0,
            }}
          >
            {index === 0 ? (
              <Input
                value={representative.name}
                onChange={(e) => {
                  onEditRepresentative(index, e.target.value);
                }}
                style={{
                  flex: 1,
                }}
              />
            ) : (
              <Flex
                align="center"
                gap={8}
                style={{ width: '100%' }}
                className={css`
                  & > div {
                    flex: 1;
                  }
                `}
              >
                <Input
                  value={representative.name}
                  onChange={(e) => {
                    onEditRepresentative(index, e.target.value);
                  }}
                  style={{
                    flex: 1,
                  }}
                />
                {index === 0 ? (
                  <div />
                ) : (
                  <Button
                    buttonType="transparent"
                    icon={
                      <BinLine
                        width={18}
                        height={18}
                        style={{
                          color: Colors.gray700,
                        }}
                      />
                    }
                    onClick={() => {
                      onRemoveRepresentative(index);
                    }}
                  />
                )}
              </Flex>
            )}
          </Form.Item>
        ))}
      </div>
      <Button
        icon={<PlusOutlined />}
        onClick={onAddRepresentative}
        style={{
          width: 'max-content',
          marginTop: 4,
        }}
      >
        {' '}
        대표자 추가
      </Button>
    </>
  );
};

export default BusinessEntityRepresentativeFormItems;
